import { render, staticRenderFns } from "./CadRecebimentoEmpresas.vue?vue&type=template&id=5b9f1eb6&"
import script from "./CadRecebimentoEmpresas.vue?vue&type=script&lang=js&"
export * from "./CadRecebimentoEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports